import {h} from 'preact';
import styles from "./style.scss"
import ReturnBack from "./ReturnBack";
import Documentation511Content from "./Documentation511Content";

const Success = () => {
    return (
        <main id="main-container" className={styles.wrapper} main-attr>
            <ReturnBack url='/info/basic'></ReturnBack>
            <Documentation511Content/>
        </main>
    );
};

export default Success;
